const CareLabelTypes = {
  FETCH_PRODUCT_DETAILS: 'FETCH_PRODUCT_DETAILS',
  FETCH_ORDER_PERMISSION_CARELABEL: 'FETCH_ORDER_PERMISSION_CARELABEL',
  UPDATE_CARE_LABEL_SWITCHES: 'UPDATE_CARE_LABEL_SWITCHES',
  GET_ALL_CARELABEL: 'GET_ALL_CARELABEL',
  UPDATE_CARE_LABEL_MARK_COMPLETE: 'UPDATE_CARE_LABEL_MARK_COMPLETE',
  GET_CARELABEL_LIBRARY: 'GET_CARELABEL_LIBRARY',
  GET_CARELABEL_GROUP: 'GET_CARELABEL_GROUP',
  GET_CARELABEL_PRODUCT_lIST: 'GET_CARELABEL_PRODUCT_lIST',
  GET_CARE_LABEL_PRODUCT_DATA: 'GET_CARE_LABEL_PRODUCT_DATA',
  GET_CARE_LAYOUT_DATA: 'GET_CARE_LAYOUT_DATA',
  CLEAR_CARE_LABEL_REDUCER: 'CLEAR_CARE_LABEL_REDUCER',
  GET_ALL_CARE_INSTRUCTION: 'GET_ALL_CARE_INSTRUCTION',
  GET_ALL_CARE_GROUP: 'GET_ALL_CARE_GROUP',
  GET_PRODUCT_LIST: 'GET_PRODUCT_LIST',
  GET_CARE_LIBRARIES_DATA: 'GET_CARE_LIBRARIES_DATA',
  GET_PRODUCT_USER_INSTRUCTION_DETAILS: 'GET_PRODUCT_USER_INSTRUCTION_DETAILS',
};

export default CareLabelTypes;
